import { INGESTION_CONSTANTS } from 'Modules/Studio/components/StudioInfo/Ingestion/utilities/Ingestion.constants';
import { IActiveIngestion } from 'Modules/Studio/components/StudioInfo/redux/ingestion.interface';
import { INGESTION_BY_TABLE_TEXT } from '../../../IngestionByDataSource.constants';

/**
 * Returns true when there is an active ingestion (running) at table level
 * @param activeIngestion
 * @param name
 * @returns
 */
export const getTableViewTableIsRunningIngestion = (
  activeIngestion: IActiveIngestion | null,
  name: string
): boolean => {
  return activeIngestion?.tables?.[name]?.status === INGESTION_CONSTANTS.RUNNING;
};

const getIsRunningAtDataSourceLevel = (activeIngestion: IActiveIngestion | null): boolean => {
  if (!activeIngestion) return false;

  return (
    activeIngestion &&
    Object.keys(activeIngestion.tables || {}).length === 0 &&
    (activeIngestion.status === INGESTION_CONSTANTS.RUNNING ||
      activeIngestion?.status === INGESTION_CONSTANTS.TRIGGERED_STOP)
  );
};

/**
 * Returns true when ingestion at table level is stopping
 * @param activeIngestion
 * @param name
 * @returns
 */
export const getTableViewTableIsDisabled = (
  activeIngestion: IActiveIngestion | null,
  name: string
): boolean => {
  const isRunningAtDataSourceLevel = getIsRunningAtDataSourceLevel(activeIngestion);

  if (isRunningAtDataSourceLevel) {
    return true;
  }
  return activeIngestion?.tables?.[name]?.status === INGESTION_CONSTANTS.TRIGGERED_STOP;
};

/**
 * Returns the tooltip text to display for the table view table ingestion button
 * @param isDisabled
 * @param isRunning
 * @returns string
 */
export const getTableViewTableTooltipText = (
  isDisabled: boolean,
  isRunning: boolean,
  activeIngestion: IActiveIngestion | null
): string => {
  const isRunningAtDataSourceLevel = getIsRunningAtDataSourceLevel(activeIngestion);

  if (isRunningAtDataSourceLevel && isDisabled) {
    return INGESTION_BY_TABLE_TEXT.tooltips.disabled.dsRunning;
  }

  if (isDisabled) {
    return INGESTION_BY_TABLE_TEXT.tooltips.disabled.stopping;
  }
  return isRunning
    ? INGESTION_BY_TABLE_TEXT.tooltips.stopTable
    : INGESTION_BY_TABLE_TEXT.tooltips.startTable;
};
